export default __webpack_public_path__ + "static/media/bottle.da521d95.svg";